import { useState, useEffect } from 'react';
import { FaHeart, FaRegHeart } from "react-icons/fa";
import { BiSolidStar } from "react-icons/bi";
import { Link, useNavigate } from 'react-router-dom';
import styles from './CardProduto.module.css';
import { useTranslation } from 'react-i18next';
import { Specifications } from '../EntrepreneurAddOrEditProduct';
import noImage from '../../assets/no-image.jpg'
import api from '../../utils/axios/api';
import { useCalculateWithFee } from '../../utils/fee';

export enum Category {
    PINTURA,
    MATERIAL_HIDRAULICO,
    ILUMINACAO,
    PISOS_REVESTIMENTOS,
    MATERIAL_CONSTRUCAO,
    FERRAMENTAS,
    MATERIAL_ELETRICO
}

export type Produto = {
    id: string;
    name: string;
    image: string;
    /** URLs complementares; a capa é `image` */
    additionalImages?: string[];
    description: string;
    createdAt: Date;
    category: Category;
    quantity: number;
    quantidadePedido: number;
    originalPrice: number,
    promotionalPrice?: number,
    brand: string,
    space: string,
    solutions: string,
    problems: string,
    storeId: string,
    storeName?: string,
    updatedAt: Date,
    rating: number,
    salesCount: number,
    ratingCount: number,
    specifications: Specifications[]
}

type CardProdutoProps = {
    produto: Produto;
}


export default function CardProduto({ produto }: CardProdutoProps): JSX.Element {
    const [isFavorite, setIsFavorite] = useState(false);
    const navigate = useNavigate()

    const { t } = useTranslation("", { keyPrefix: "cardProduto" });
    const calcWithFee = useCalculateWithFee();

    function favoriteProduct(event: any) {
        event?.preventDefault()
        event?.stopPropagation()
        const clientId = localStorage.getItem('clientId')

        if(!clientId){
            navigate('/Login')
        } else if (isFavorite){
            api.delete(`/favorite/${produto.id}/${clientId}`)
            .then(() => {
                setIsFavorite(false)
            }).catch(() => {
                alert('Erro ao remover favorito')
            })
        } else {
            api.post(`/favorite`, {
                clientId: localStorage.getItem('clientId'),
                productId: produto.id
            })
            .then(() => {
                setIsFavorite(true)
            })
            .catch(() => {
                alert('Erro ao favoritar produto')
            })
        }
    }

    useEffect(() => {
        //Verificação se o cliente está logado
        if(localStorage.getItem('clientId')){
            api.get(`/favorite/client/${localStorage.getItem('clientId')}/product/${produto.id}`)
            .then((response) => {
            setIsFavorite(response.data.isFavorite)
            })
        } else {
            setIsFavorite(false)
        }        
    }, []);

    return (
        <Link key={produto.id} className={styles.cardContainer} to={`/DescricaoDeProduto/${produto.id}`}>
            <div className={styles.imagemContainer}>
                <button type="button" onClick={favoriteProduct}>
                    {isFavorite ? (
                        <FaHeart className={styles.favoritarIcon} style={{ color: '#D8372C' }} />
                    ) : (
                        <FaRegHeart className={styles.favoritarIcon} />
                    )}
                </button>

                <div className={styles.imagemDiv}>
                    <img src={produto.image ?? noImage} alt={produto.name} onError={(e) => {
                        e.currentTarget.onerror = null;
                        e.currentTarget.src = noImage;
                    }} className={styles.imagemProduto} />
                </div>
            </div>
            <div className={styles.cardContent}>
                {produto.promotionalPrice && (
                    <div className={styles.promotionContainer}>
                        {t("promotion")}
                    </div>
                )}

                <div className={styles.productName}>
                    <h3 className={styles.productH3}>{produto.name}</h3>
                    {produto.storeName && (
                        <span className={styles.storeName}>
                            {produto.storeName.length >30 ? `${produto.storeName.slice(0, 20)}...` : produto.storeName}
                        </span>
                    )}
                </div>

                <div className={styles.footer}>
                    <div className={styles.avaliacaoContainer}>
                        <BiSolidStar className={styles.iconeAvaliacao} />
                        <span className={styles.avaliacaoProduto}>{produto.rating}</span>
                    </div>
                    {
                        produto.promotionalPrice
                            ?
                            <p className={styles.precoProduto}>R$ {calcWithFee(produto.promotionalPrice)}</p>
                            : <p className={styles.precoProduto}>R$ {calcWithFee(produto.originalPrice)}</p>
                    }
                </div>
            </div>
        </Link>
    );
}
